@if ((priceSheet$ | async); as priceSheet) {
  <nb-card>
    <nb-card-header>
      @if (!priceSheet.is_benchmark) {
        {{ "Price sheet title" | translate }}
      }
      @if (priceSheet.is_benchmark) {
        {{ "Benchmark price sheet" | translate }}
      }
      @if (canEdit && !priceSheet.is_benchmark) {
        <div class="btn-grp">
          <div>
            <span
              class="ps-icon"
              (click)="updatePriceSheet(priceSheet)"
            >
              <i class="fa-light fa-pen-to-square"></i>
            </span>
          </div>
          <div>
            <span
              class="ps-icon"
              [class]="priceSheet.is_default ? 'undeletable' : 'deletable'"
              (click)="deletePricesheet(priceSheet)"
            >
              <i class="fa-light fa-trash-can"></i>
            </span>
          </div>
        </div>
      }
    </nb-card-header>
    <nb-card-body>
      <div class="container-fluid">
        <div class="row m-0 pt-3 justify-content-center">
          <div class="col-12">
            <div>
              <table class="table">
                <tbody>
                  <!-- Price sheet Label -->
                  <tr>
                    @if (currentAssetId) { <td class="price-tier-cell"></td> }
                    <td>{{ 'Price sheet label' | translate }}</td>
                    <td>{{ priceSheet.label || '-' }}</td>
                  </tr>
                  <!-- Author + Last modification (merged) -->
                  <tr>
                    @if (currentAssetId) { <td class="price-tier-cell"></td> }
                    <td>{{ 'Price sheet author' | translate }}</td>
                    <td class="author-cell">
                      <span>
                        {{ priceSheet.author | ngxUsername }},
                        {{ 'on' | translate }} {{ priceSheet.modified_on | date:'dd MMMM yyyy':'':lang }}
                      </span>
                      @if (priceSheet.author?.email) {
                        <a class="email-icon" [href]="'mailto:' + priceSheet.author.email" [title]="'Send email' | translate">
                          <i class="fa-light fa-envelope"></i>
                        </a>
                      }
                    </td>
                  </tr>
                  <!-- Type d'ouvrage -->
                  <tr>
                    @if (currentAssetId) { <td class="price-tier-cell"></td> }
                    <td>{{ 'core.utils.investment-filter-tab.technical-nomenclature.asset-type' | translate }}</td>
                    <td> {{ (assetType$ | async)?.name }} </td>
                  </tr>
                  <!-- Investment Type -->
                  <tr>
                    @if (currentAssetId) { <td class="price-tier-cell"></td> }
                    <td>{{ 'Investment type' | translate }}</td>
                    <td>{{ priceSheet.investment_type?.name || '-' }}</td>
                  </tr>
                  <!-- Min Price -->
                  <tr>
                    @if (currentAssetId) {
                      <td class="price-tier-cell">
                      </td>
                    }
                    <td>{{ 'Min price' | translate }}</td>
                    <td>
                      @if (priceSheet.min_price) {
                        {{ priceSheet.min_price | thousandsSeparator }} {{ currency }}
                        @if (priceSheet.quantity_unit) {
                          / {{ priceSheet.quantity_unit.name }}
                        } @else {
                          / {{ "unit" | translate }}
                        }
                      } @else {
                        -
                      }
                    </td>
                  </tr>
                  <!-- Median price-->
                  <tr>
                    @if (currentAssetId) {
                      <td class="price-tier-cell">
                      </td>
                    }
                    <td>{{ 'Price Median' | translate }}</td>
                    <td>
                      {{ priceSheet.average_price | thousandsSeparator }} {{ currency }}
                      @if (priceSheet.quantity_unit) {
                        / {{ priceSheet.quantity_unit.name }}
                      } @else {
                        / {{ "unit" | translate }}
                      }
                    </td>
                  </tr>
                  <!-- Max Price -->
                  <tr>
                    @if (currentAssetId) {
                      <td class="price-tier-cell">
                      </td>
                    }
                    <td>{{ 'Max price' | translate }}</td>
                    <td>
                      @if (priceSheet.max_price) {
                        {{ priceSheet.max_price | thousandsSeparator }} {{ currency }}
                        @if (priceSheet.quantity_unit) {
                          / {{ priceSheet.quantity_unit.name }}
                        } @else {
                          / {{ "unit" | translate }}
                        }
                      } @else {
                        -
                      }
                    </td>
                  </tr>
                  <!-- Price sheet comment (3 lines) -->
                  <tr>
                    @if (currentAssetId) { <td class="price-tier-cell"></td> }
                    <td class="comment-cell">{{ 'Comment' | translate }}</td>
                    <td class="comment-cell">
                      <div #commentDiv class="comment-text" [title]="priceSheet.comments || ''">{{ displayedComment }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer class="text-right">
      <div class="container-fluid">
        <div class="row m-0 pb-2">
          <div class="col-2 offset-10">
            <button nbButton type="submit" (click)="close()" class="w-100">{{ 'OK' | translate }}</button>
          </div>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
}
